var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTab2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.0498 1.00354H28.0498C27.4968 1.00354 27.0498 1.45154 27.0498 2.00354V30.0035C27.0498 30.3875 27.2708 30.7385 27.6158 30.9045C27.7548 30.9705 27.9028 31.0035 28.0498 31.0035C28.2728 31.0035 28.4938 30.9285 28.6748 30.7845L38.4008 23.0035H62.0498C62.6028 23.0035 63.0498 22.5555 63.0498 22.0035V2.00354C63.0498 1.45154 62.6028 1.00354 62.0498 1.00354Z",
    fill: "#AD186A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0498 43.0035C53.9158 43.0035 57.0498 39.8695 57.0498 36.0035C57.0498 32.1375 53.9158 29.0035 50.0498 29.0035C46.1838 29.0035 43.0498 32.1375 43.0498 36.0035C43.0498 39.8695 46.1838 43.0035 50.0498 43.0035Z",
    fill: "#157B7D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0498 43.0035C17.9158 43.0035 21.0498 39.8695 21.0498 36.0035C21.0498 32.1375 17.9158 29.0035 14.0498 29.0035C10.1838 29.0035 7.0498 32.1375 7.0498 36.0035C7.0498 39.8695 10.1838 43.0035 14.0498 43.0035Z",
    fill: "#157B7D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5928 49.7295C22.4918 48.4855 18.9568 47.0035 14.0498 47.0035C9.0778 47.0035 5.5608 48.4815 3.4858 49.7205C1.9838 50.6165 1.0498 52.2635 1.0498 54.0175V60.0035C1.0498 60.5565 1.4968 61.0035 2.0498 61.0035H26.0498C26.6028 61.0035 27.0498 60.5565 27.0498 60.0035V54.0385C27.0498 52.2755 26.1088 50.6245 24.5928 49.7295Z",
    fill: "#157B7D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5928 49.7295C58.4918 48.4855 54.9568 47.0035 50.0498 47.0035C45.0778 47.0035 41.5608 48.4815 39.4858 49.7205C37.9838 50.6165 37.0498 52.2635 37.0498 54.0175V60.0035C37.0498 60.5565 37.4968 61.0035 38.0498 61.0035H62.0498C62.6028 61.0035 63.0498 60.5565 63.0498 60.0035V54.0385C63.0498 52.2755 62.1088 50.6245 60.5928 49.7295Z",
    fill: "#157B7D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTab2);
export default __webpack_public_path__ + "static/media/tab_2.f5dcfc2eced8e875d395f51bc33bdc62.svg";
export { ForwardRef as ReactComponent };